import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { CoreMeterpoint } from "./coreMeterpoint"
import { ICoreMeterpoint } from "./coreMeterpoint.types"
import { Meterpoint } from "@/api/backofficeRest/generated/model"

export type ICoreMeterpointRaw = Meterpoint

export const CoreMeterpointParser: IParser<
  ICoreMeterpoint,
  ICoreMeterpointRaw
> = {
  toDomain: (data: ICoreMeterpointRaw) => {
    try {
      return new CoreMeterpoint(
        Number(data.id),
        data.identifier,
        data.type,
        data.supply_status ?? "",
        dayjs(data.from_date),
        data.uk_profile_class ?? "",
        data.uk_gsp_group ?? "",
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
